import React, { useEffect, useState } from 'react';
import {Helmet} from "react-helmet-async";
import Loadable from '@loadable/component'
import {useParams } from 'react-router-dom';
import _ from 'lodash';
import {injectIntl} from 'react-intl';
import Languages from 'locales';
import Favicon from './../config/favicon.png'
import FBPicture from 'pages/leadbest-official-website/assets/images/meta-image.jpg'

interface HelmetHeadProps {
  pageTitle?:string;
  intl:any,
  fontFamilys: {
    name:string,
    value:string
  }[]
}

const LayoutHelmetHead = injectIntl((props:HelmetHeadProps) => {
  const { intl, fontFamilys, pageTitle } = props;
  const params:{lang?:string} = useParams();
  const LangsKeys = _.values(Languages);
  const langPathRegex = LangsKeys.length > 1 ? _.chain(LangsKeys).reduce((a,b) => a.keys +  `|${b.keys}`).value() : LangsKeys[0].keys;

  return (
    <Helmet>
      <title>{intl.formatMessage({id: pageTitle || `project.website.title`})}</title>
      {/* <link rel="shortcut icon" href={Favicon} /> */}
      <meta name="description" content={intl.formatMessage({id:`project.website.description`})} />
      <meta property="og:image:alt" content={intl.formatMessage({ id: `project.website.title` })} />
      <meta property="og:title" content={intl.formatMessage({ id: `project.website.title` })} />
      <meta property="og:description" content={intl.formatMessage({ id: `project.website.description` })} />
      <meta property="og:image" content={`https://www.leadbestgroup.com${FBPicture}`} />
      <meta property="fb:app_id" content={`${window.Config.FB_APP_ID}`} />
      {
        fontFamilys.map((item:any,index:number) => {
          return <link key={index} href={`https://fonts.googleapis.com/css2?family=${item.value}&display=swap`} rel="stylesheet"/> 
        })
      }
      {
        langPathRegex.split('|').map((lang:string,index:number) => {
          const pathname:string = window.location.pathname.replace(`/${params?.lang}` || '', '');
          return <link key={index} rel="alternate" href={`${window.origin}/${lang}${pathname}`} hrefLang={lang} />
        })
      }
      <link rel="alternate" href={window.location.href.replace(`/${params?.lang}` || '', '')} hrefLang="x-default" />
    </Helmet>
  );
})

export default LayoutHelmetHead;